export default {
  lstTab: {
    economy: 'Vĩ mô',
    watchlist: 'Danh mục',
    corporate: 'Toàn thị trường',
  },
};
